(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmp-flavor-scene"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.lmp-scene__tab'));
      var current = Number(root.dataset.start) || 0;
      function show(i, focus) {
        if (i < 0) i = tabs.length - 1;
        if (i >= tabs.length) i = 0;
        if (i !== current) root.classList.add('has-moved');
        current = i;
        var tab = tabs[i];
        root.style.setProperty('--scene-bg', tab.dataset.bg);
        root.style.setProperty('--scene-fg', tab.dataset.fg);
        root.querySelectorAll('[data-i]').forEach(function (el) {
          if (el.classList.contains('lmp-scene__tab')) return;
          el.classList.toggle('is-active', Number(el.dataset.i) === i);
        });
        tabs.forEach(function (t, k) {
          t.setAttribute('aria-selected', String(k === i));
          t.tabIndex = k === i ? 0 : -1;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { show(k, false); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); show(k + 1, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); show(k - 1, true); }
        });
      });
      // Glisser le doigt pour changer de parfum
      var x0 = null, y0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5 && !e.target.closest('.lmp-scene__tabs')) show(current + (dx < 0 ? 1 : -1), false);
        x0 = null;
      }, { passive: true });
      // Ordinateur : glisser à la souris…
      var mx = null, my = null;
      root.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('a, button')) return;
        mx = e.clientX; my = e.clientY;
        root.classList.add('is-dragging');
      });
      window.addEventListener('pointerup', function (e) {
        if (mx === null) return;
        var dx = e.clientX - mx, dy = e.clientY - my;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1), false);
        mx = null;
        root.classList.remove('is-dragging');
      });
      // … ou balayer horizontalement le pavé tactile
      var acc = 0, lock = 0;
      root.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        if (Date.now() < lock) return;
        acc += e.deltaX;
        if (Math.abs(acc) > 60) { show(current + (acc > 0 ? 1 : -1), false); acc = 0; lock = Date.now() + 700; }
      }, { passive: false });
      // Les photos sont en « lazy » : dès que la section approche, on les charge toutes pour des fondus sans saut
      var imgs = root.querySelectorAll('.lmp-scene__photos img');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (en) { return en.isIntersecting; })) { imgs.forEach(function (im) { im.loading = 'eager'; }); io.disconnect(); }
        }, { rootMargin: '600px 0px' });
        io.observe(root);
      }
    }
    function boot() { document.querySelectorAll('[data-lmp-scene]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-lmp-scene]');
      if (!root) return;
      var i = Number(e.target.dataset.i);
      var tab = root.querySelectorAll('.lmp-scene__tab')[i];
      if (tab) tab.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmp-flavors"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.lmp-flavor__flip');
    if (!btn) return;
    var card = btn.closest('.lmp-flavor');
    var on = !card.classList.contains('is-flipped');
    card.classList.toggle('is-flipped', on);
    btn.setAttribute('aria-pressed', String(on));
    btn.textContent = on ? 'Voir le sachet' : 'Voir en vrai';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmp-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FLAVORS = {
      noir: { name: 'Le Noir 73 %', text: 'Intense, direct, sans détour. Vous aimez le vrai chocolat, et ça se voit.' },
      lait: { name: 'Le Lait 39 %', text: 'Le classique qui met tout le monde d’accord, en plus intense.' },
      blanc: { name: 'Le Blanc', text: 'Doux, réconfortant, le câlin en sachet.' },
      blond: { name: 'Le Blond caramélisé', text: 'Curieux et gourmand : biscuit sablé, vanille, pointe de sel.' },
      pistache: { name: 'La Pistache', text: 'Toujours un coup d’avance sur les tendances.' }
    };
    function init(card) {
      if (card.dataset.ready) return;
      card.dataset.ready = '1';
      var votes = {};
      var panels = card.querySelectorAll('.lmp-quiz__panel');
      var result = card.querySelector('.lmp-quiz__result');
      function show(i) {
        panels.forEach(function (p, k) { p.hidden = k !== i; });
        result.hidden = i < panels.length;
        if (i >= panels.length) {
          var best = Object.keys(votes).sort(function (a, b) { return votes[b] - votes[a]; })[0] || 'lait';
          var f = FLAVORS[best] || FLAVORS.lait;
          result.querySelector('[data-result-name]').textContent = f.name;
          result.querySelector('[data-result-text]').textContent = f.text;
          result.querySelector('a').focus({ preventScroll: true });
        } else if (i > 0) {
          panels[i].querySelector('button').focus({ preventScroll: true });
        }
      }
      var step = 0;
      card.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-vote]');
        if (btn) { votes[btn.dataset.vote] = (votes[btn.dataset.vote] || 0) + 1; step += 1; show(step); return; }
        if (e.target.closest('[data-restart]')) { votes = {}; step = 0; show(0); }
      });
      result.hidden = true;
    }
    function boot() { document.querySelectorAll('[data-lmp-quiz]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
